import React from "react";
import ReactDOM from "react-dom";
import Dash from "./ui/Dash";
import App from "./App";


const stripePublicKey = process.env.NODE_ENV === 'production' ? 'pk_live_d7awglxvpWtJF2U8LyO8bY7d' : 'pk_test_cjo4JxFIIZoMjXaV74HzBieH';

const app = new App({stripePublicKey});

ReactDOM.render(<Dash app={app} />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js